import React from 'react';
import LocationManagerDiscountRow from './LocationManagerDiscountRow';

const LocationManagerDiscount = ({
  nrcDiscountTotal,
  nrcDiscountPercent,
  rcDiscountPercent,
  rcDiscountTotal,
  isQuoteDiscountTypeManager,
}) => {
  return (
    <>
      <LocationManagerDiscountRow
        label="msg_manager_discount_nrc"
        value={nrcDiscountPercent}
        discountTotal={nrcDiscountTotal}
        isQuoteDiscountTypeManager={isQuoteDiscountTypeManager}
      />
      <LocationManagerDiscountRow
        label="msg_manager_discount_rc"
        value={rcDiscountPercent}
        discountTotal={rcDiscountTotal}
        isQuoteDiscountTypeManager={isQuoteDiscountTypeManager}
      />
    </>
  );
};

export default LocationManagerDiscount;
